import React from 'react';

/**
 * What a list or result area shows when there is nothing yet: an icon, one line
 * saying what is missing, one line saying what to do, and an optional button.
 */
const EmptyState = ({ icon, title, message, action, className = '' }) => {
  return (
    <div className={`flex flex-col items-center justify-center px-6 py-12 text-center ${className}`}>
      {icon && (
        <div className="mb-3 flex size-11 items-center justify-center rounded-full bg-ui-muted text-ui-ink-3 [&>svg]:size-5">
          {icon}
        </div>
      )}
      <h3 className="text-[15px] font-semibold text-ui-ink">{title}</h3>
      {message && <p className="mt-1 max-w-md text-sm text-ui-ink-2">{message}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};

export default EmptyState;
